export const CyItems = {
  PageHeader: "PageHeader",
  PlaylistsButton: "PlaylistsButton",
  ItemTitle: "ItemTitle",
} as const;
